import React, { useState, useEffect } from "react";
import styled from "styled-components";
import Footer from "../Common/Footer";
import Nav from "../Common/Nav";
import CustomTextField from "../Common/CustomTextField";
import CustomTextArea from "../Common/CustomTextArea";
import CustomDropdown from "../Common/CustomDropDown";
import { Button } from "semantic-ui-react";
import TrainingHospital from "../Common/TrainingHospital";
import Specialty from "../Common/Specialty";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import PageLoader from "../Common/PageLoader";
import {
  getApiClient,
  makeStandardApiErrorHandler,
} from "../../server/get_api_client";
import toast from "react-hot-toast";

const Options = [
  {
    key: 100000000,
    value: 100000000,
    text: "I Am Currently Looking For Help With This",
  },
  {
    key: 100000001,
    value: 100000001,
    text: "I'd Like To Learn More About This",
  },
  {
    key: 100000002,
    value: 100000002,
    text: "I Am Not Interested",
  },
];

function FirstMeeting() {
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const [legalFirstName, setLegalFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [suffix, setSuffix] = useState("");
  const [birthDate, setBirthDate] = useState("");
  const [residencySpecialty, setResidencySpecialty] = useState("");
  const [residencyHospital, setResidencyHospital] = useState("");
  const [residencyCompletionDate, setResidencyCompletionDate] = useState("");
  const [fellowshipSpecialty, setFellowshipSpecialty] = useState("");
  const [fellowshipHospital, setFellowshipHospital] = useState("");
  const [fellowshipCompletionDate, setFellowshipCompletionDate] = useState("");
  // const [meetingOption1, setMeetingOption1] = useState("");
  // const [meetingOption2, setMeetingOption2] = useState("");
  // const [meetingOption3, setMeetingOption3] = useState("");
  // const [additionalInfo, setAdditionalInfo] = useState("");
  const [studentLoanManagement, setStudentLoanManagement] = useState("");
  const [disabilityInsurance, setDisabilityInsurance] = useState("");
  const [investmentManagement, setInvestmentManagement] = useState("");
  const [taxPlanning, setTaxPlanning] = useState("");
  const [lifeInsurance, setLifeInsurance] = useState("");
  const [financialPlan, setFinancialPlan] = useState("");
  const [retirementPlanning, setRetirementPlanning] = useState("");
  const [estatePlanning, setEstatePlanning] = useState("");
  const [employeeBenefits, setEmployeeBenefits] = useState("");
  const [firstHomePurchase, setFirstHomePurchase] = useState("");
  const [taxPreparation, setTaxPreparation] = useState("");
  const [incorporation, setIncorporation] = useState("");
  const [contractReview, setContractReview] = useState("");
  const [otherResidencySpecialty, setOtherResidencySpecialty] = useState(false);
  const [otherResidencyHospital, setOtherResidencyHospital] = useState(false);
  const [otherFellowshipSpecialty, setOtherFellowshipSpecialty] = useState(false);
  const [otherFellowshipHospital, setOtherFellowshipHospital] = useState(false);
  const { leadid } = useParams();

  const handleUpdateRecord = async () => {
    setIsLoading(true);
    const recordData = {
      entity: "leads",
      id: leadid,
      attributes: [
        {
          fieldname: "firstname",
          value: legalFirstName,
          type: "string",
          entity: null,
        },
        {
          fieldname: "lastname",
          value: lastName,
          type: "string",
          entity: null,
        },
        {
          fieldname: "hip_suffix",
          value: suffix,
          type: "string",
          entity: null,
        },
        {
          fieldname: "new_birthday",
          value: birthDate,
          type: "date",
          entity: null,
        },
        {
          fieldname: "hip_otherresidencyspecialty",
          value: otherResidencySpecialty,
          type: "boolean",
          entity: null,
        },
        otherResidencySpecialty ? {
          fieldname: "hip_residencyspecialtynametext",
          value: residencySpecialty,
          type: "string",
          entity: null,
        } :
          {
            fieldname: "hip_ResidencySpecialty",
            value: residencySpecialty,
            type: "lookup",
            entity: "hip_specialtynews",
          },
        {
          fieldname: "hip_otherresidencyhospital",
          value: otherResidencyHospital,
          type: "boolean",
          entity: null,
        },
        otherResidencyHospital ? {
          fieldname: "hip_residencyhospitalnametext",
          value: residencyHospital,
          type: "string",
          entity: null,
        } : {
          fieldname: "hip_Residencyhospital",
          value: residencyHospital,
          type: "lookup",
          entity: "accounts",
        },
        {
          fieldname: "new_completiondate",
          value: residencyCompletionDate,
          type: "date",
          entity: null,
        },
        {
          fieldname: "hip_otherfellowshipspecialty",
          value: otherFellowshipSpecialty,
          type: "boolean",
          entity: null,
        },
        otherFellowshipSpecialty ? {
          fieldname: "hip_fellowshipspecialtynametext",
          value: fellowshipSpecialty,
          type: "string",
          entity: null,
        } : {
          fieldname: "hip_FellowshipSpecialtyy",
          value: fellowshipSpecialty,
          type: "lookup",
          entity: "hip_specialtynews",
        },
        {
          fieldname: "hip_otherfellowshiphospital",
          value: otherFellowshipHospital,
          type: "boolean",
          entity: null,
        },
        otherFellowshipHospital ? {
          fieldname: "hip_fellowshiphospitalnametext",
          value: fellowshipHospital,
          type: "string",
          entity: null,
        } : {
          fieldname: "hip_FellowshipHospital",
          value: fellowshipHospital,
          type: "lookup",
          entity: "accounts",
        },
        {
          fieldname: "new_completiondatef",
          value: fellowshipCompletionDate,
          type: "date",
          entity: null,
        },
        // {
        //   fieldname: "new_firstmeetingdateandtimeoption1",
        //   value: meetingOption1,
        //   type: "date",
        //   entity: null,
        // },
        // {
        //   fieldname: "new_firstmeetingdateandtimeoption2",
        //   value: meetingOption2,
        //   type: "date",
        //   entity: null,
        // },
        // {
        //   fieldname: "new_firstmeetingdateandtimeoption3",
        //   value: meetingOption3,
        //   type: "date",
        //   entity: null,
        // },
        // {
        //   fieldname: "new_additionalinformationfromclient",
        //   value: additionalInfo,
        //   type: "string",
        //   entity: null,
        // },
        {
          fieldname: "new_studentloanmanagement",
          value: studentLoanManagement,
          type: "optionset",
          entity: null,
        },
        {
          fieldname: "new_disabilityinsurance",
          value: disabilityInsurance,
          type: "optionset",
          entity: null,
        },
        {
          fieldname: "new_investmentmanagement",
          value: investmentManagement,
          type: "optionset",
          entity: null,
        },
        {
          fieldname: "new_taxplanning",
          value: taxPlanning,
          type: "optionset",
          entity: null,
        },
        {
          fieldname: "new_lifeinsurance",
          value: lifeInsurance,
          type: "optionset",
          entity: null,
        },
        {
          fieldname: "new_financialplan",
          value: financialPlan,
          type: "optionset",
          entity: null,
        },
        {
          fieldname: "new_retirementplanning",
          value: retirementPlanning,
          type: "optionset",
          entity: null,
        },
        {
          fieldname: "new_estateplanning",
          value: estatePlanning,
          type: "optionset",
          entity: null,
        },
        {
          fieldname: "new_employeebenefits",
          value: employeeBenefits,
          type: "optionset",
          entity: null,
        },
        {
          fieldname: "new_firsthomepurchase",
          value: firstHomePurchase,
          type: "optionset",
          entity: null,
        },
        {
          fieldname: "new_taxpreparation",
          value: taxPreparation,
          type: "optionset",
          entity: null,
        },
        {
          fieldname: "new_incorporation",
          value: incorporation,
          type: "optionset",
          entity: null,
        },
        {
          fieldname: "new_contractreview",
          value: contractReview,
          type: "optionset",
          entity: null,
        },
      ],
    };
    try {
      await getApiClient().UpdateLead(recordData);
      toast.success("First meeting information submitted successfully");
      navigate("/Submitted");
    } catch (error) {
      makeStandardApiErrorHandler((error) => toast.error(error));
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const response = await getApiClient().getLeadInfo(leadid);
        const data = response.data;
        setLegalFirstName(data.firstname || "");
        setLastName(data.lastname || "");
        setSuffix(data.hip_suffix || "");

        setBirthDate(data.new_birthday || "");
        setResidencySpecialty(data._hip_residencyspecialty_value || "");
        setResidencyHospital(data._hip_residencyhospital_value || "");
        setResidencyCompletionDate(
          (data.new_completiondate && data.new_completiondate.split("T")[0]) ||
          ""
        );
        setFellowshipSpecialty(data._hip_fellowshipspecialtyy_value || "");
        setFellowshipHospital(data._hip_fellowshiphospital_value || "");
        setFellowshipCompletionDate(
          (data.new_completiondatef &&
            data.new_completiondatef.split("T")[0]) ||
          ""
        );
        // setMeetingOption1(
        //   (data.new_firstmeetingdateandtimeoption1 &&
        //     data.new_firstmeetingdateandtimeoption1.slice(0, 16)) ||
        //   ""
        // );
        // setMeetingOption2(
        //   (data.new_firstmeetingdateandtimeoption2 &&
        //     data.new_firstmeetingdateandtimeoption2.slice(0, 16)) ||
        //   ""
        // );
        // setMeetingOption3(
        //   (data.new_firstmeetingdateandtimeoption3 &&
        //     data.new_firstmeetingdateandtimeoption3.slice(0, 16)) ||
        //   ""
        // );
        // setAdditionalInfo(data.new_additionalinformationfromclient || "");
        setStudentLoanManagement(data.new_studentloanmanagement || "");
        setDisabilityInsurance(data.new_disabilityinsurance || "");
        setInvestmentManagement(data.new_investmentmanagement || "");
        setTaxPlanning(data.new_taxplanning || "");
        setLifeInsurance(data.new_lifeinsurance || "");
        setFinancialPlan(data.new_financialplan || "");
        setRetirementPlanning(data.new_retirementplanning || "");
        setEstatePlanning(data.new_estateplanning || "");
        setEmployeeBenefits(data.new_employeebenefits || "");
        setFirstHomePurchase(data.new_firsthomepurchase || "");
        setTaxPreparation(data.new_taxpreparation || "");
        setIncorporation(data.new_incorporation || "");
        setContractReview(data.new_contractreview || "");
        setOtherResidencySpecialty(data.hip_otherresidencyspecialty || false);
        setOtherResidencyHospital(data.hip_otherresidencyhospital || false);
        setOtherFellowshipSpecialty(data.hip_otherfellowshipspecialty || false);
        setOtherFellowshipHospital(data.hip_otherfellowshiphospital || false);
      } catch (error) {
        if (error.response?.status === 405) {

          navigate("/Qualified", {
            state: { source: "getLeadInfo", leadid },
          });
          window.location.reload();
        }
        else {
          makeStandardApiErrorHandler((err) => toast.error(err))(error);
        }
      }
      finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [leadid]);

  return (
    <>
      <PageLoader isLoading={isLoading} />
      <Nav />
      <Container>
        <TopSection>
          <Title>First Meeting Scheduling & Interests</Title>
        </TopSection>

        <BottomSection>
          <Seciton>
            <Text>Personal Information</Text>
            <FieldContianer>
              <CustomTextField
                firstmeeting={true}
                Active={true}
                Title="First Name:"
                placeholder="Enter First Name"
                value={legalFirstName}
                onChange={setLegalFirstName}
              />
              <CustomTextField
                firstmeeting={true}
                Active={true}
                Title="Last Name:"
                placeholder="Enter Last Name"
                value={lastName}
                onChange={setLastName}
              />
              <CustomTextField
                firstmeeting={true}
                Active={true}
                Title="Suffix:"
                placeholder="Enter Suffix"
                value={suffix}
                onChange={setSuffix}
              />
              <CustomTextField
                firstmeeting={true}
                Active={true}
                Title="Birthdate:"
                Type="date"
                value={birthDate}
                onChange={setBirthDate}
              />
            </FieldContianer>
          </Seciton>
          <Seciton>
            <Text>Residency Information</Text>
            <FieldContianer>
              <div style={{ display: "flex", alignItems: "flex-start", gap: "10px", flexDirection: "column", width: "100%", justifyContent: "start" }}>
                {otherResidencySpecialty ? (
                  <CustomTextField
                    firstmeeting={true}
                    Active={true}
                    Title="Residency Specialty"
                    placeholder="Enter Specialty Name"
                    value={residencySpecialty}
                    onChange={setResidencySpecialty}
                  />
                ) : (
                  <Specialty
                    firstmeeting={true}
                    Active={true}
                    value={residencySpecialty}
                    Title="Residency Specialty"
                    type={591930000}
                    onChange={setResidencySpecialty}
                  />
                )}
                <CheckboxContainer>
                  <Checkbox
                    type="checkbox"
                    id="otherResidencySpecialty"
                    checked={otherResidencySpecialty}
                    onChange={(e) => { setOtherResidencySpecialty(e.target.checked); setResidencySpecialty("") }}
                  />
                  <CheckboxLabel htmlFor="otherResidencySpecialty">
                    Other specialty?
                  </CheckboxLabel>
                </CheckboxContainer>
              </div>
              <div style={{ display: "flex", alignItems: "flex-start", gap: "10px", flexDirection: "column", width: "100%", justifyContent: "start" }}>

                {otherResidencyHospital ? (
                  <CustomTextField
                    firstmeeting={true}
                    Active={true}
                    Title="Residency Hospital"
                    placeholder="Enter Hospital Name"
                    value={residencyHospital}
                    onChange={setResidencyHospital}
                  />
                ) : (
                  <>
                    <TrainingHospital
                      firstmeeting={true}
                      Active={true}
                      value={residencyHospital}
                      Title="Residency Hospital"
                      type={591930000}
                      onChange={setResidencyHospital}
                    />
                  </>
                )}
                <CheckboxContainer>
                  <Checkbox
                    type="checkbox"
                    id="otherResidencyHospital"
                    checked={otherResidencyHospital}
                    onChange={(e) => { setOtherResidencyHospital(e.target.checked); setResidencyHospital("") }}
                  />
                  <CheckboxLabel htmlFor="otherResidencyHospital">
                    Other hospital?
                  </CheckboxLabel>
                </CheckboxContainer>
              </div>
              <CustomTextField
                firstmeeting={true}
                Active={true}
                Title="Completion Date:"
                Type={"date"}
                value={residencyCompletionDate}
                onChange={setResidencyCompletionDate}
              />
            </FieldContianer>

          </Seciton>
          <Seciton>
            <Text>Fellowship Information</Text>
            <FieldContianer>
              <div style={{ display: "flex", alignItems: "flex-start", gap: "10px", flexDirection: "column", width: "100%", justifyContent: "start" }}>

                {otherFellowshipSpecialty ? (
                  <CustomTextField
                    firstmeeting={true}
                    Active={true}
                    Title="Fellowship Specialty"
                    placeholder="Enter Specialty Name"
                    value={fellowshipSpecialty}
                    onChange={setFellowshipSpecialty}
                  />
                ) : (
                  <Specialty
                    firstmeeting={true}
                    Active={true}
                    value={fellowshipSpecialty}
                    Title="Fellowship Specialty"
                    type={591930001}
                    onChange={setFellowshipSpecialty}
                  />
                )}
                <CheckboxContainer>
                  <Checkbox
                    type="checkbox"
                    id="otherFellowshipSpecialty"
                    checked={otherFellowshipSpecialty}
                    onChange={(e) => { setOtherFellowshipSpecialty(e.target.checked); setFellowshipSpecialty("") }}
                  />
                  <CheckboxLabel htmlFor="otherFellowshipSpecialty">
                    Other specialty?
                  </CheckboxLabel>
                </CheckboxContainer>
              </div>
              <div style={{ display: "flex", alignItems: "flex-start", gap: "10px", flexDirection: "column", width: "100%", justifyContent: "start" }}>
                {otherFellowshipHospital ? (
                  <CustomTextField
                    firstmeeting={true}
                    Active={true}
                    Title="Fellowship Hospital"
                    placeholder="Enter Hospital Name"
                    value={fellowshipHospital}
                    onChange={setFellowshipHospital}
                  />
                ) : (
                  <TrainingHospital
                    firstmeeting={true}
                    Active={true}
                    value={fellowshipHospital}
                    Title="Fellowship Hospital"
                    type={591930001}
                    onChange={setFellowshipHospital}
                  />
                )}
                <CheckboxContainer>
                  <Checkbox
                    type="checkbox"
                    id="otherFellowshipHospital"
                    checked={otherFellowshipHospital}
                    onChange={(e) => { setOtherFellowshipHospital(e.target.checked); setFellowshipHospital("") }}
                  />
                  <CheckboxLabel htmlFor="otherFellowshipHospital">
                    Other hospital?
                  </CheckboxLabel>
                </CheckboxContainer>
              </div>
              <CustomTextField
                firstmeeting={true}
                Active={true}
                Title="Completion Date:"
                Type={"date"}
                value={fellowshipCompletionDate}
                onChange={setFellowshipCompletionDate}
              />
            </FieldContianer>
          </Seciton>
          {/* <Seciton>
            <Text>Preferred Meeting Date & Time (Mention in Pacific Time)</Text>
            <FieldContianer>
              <CustomTextField
                firstmeeting={true}
                Active={true}
                Title="Option 1:"
                Type={"datetime-local"}
                value={meetingOption1}
                onChange={setMeetingOption1}
              />
              <CustomTextField
                firstmeeting={true}
                Active={true}
                Title="Option 2:"
                Type={"datetime-local"}
                value={meetingOption2}
                onChange={setMeetingOption2}
              />
              <CustomTextField
                firstmeeting={true}
                Active={true}
                Title="Option 3:"
                Type={"datetime-local"}
                value={meetingOption3}
                onChange={setMeetingOption3}
              />
            </FieldContianer>
            <div style={{ padding: "20px 40px", width: "100%" }}>
              <CustomTextArea
                firstmeeting={true}
                Active={true}
                Flex={true}
                Title="Additional Information or Special Requirements:"
                value={additionalInfo}
                onChange={setAdditionalInfo}
              />
            </div>
          </Seciton> */}
          <Seciton>
            <Text>Meeting Topics & Interests</Text>
            <FieldContianer>
              <CustomDropdown
                firstmeeting={true}
                options={Options}
                Active={true}
                Title="Student Loan Management"
                value={studentLoanManagement}
                onChange={setStudentLoanManagement}
              />
              <CustomDropdown
                firstmeeting={true}
                options={Options}
                Active={true}
                Title="Disability Insurance:"
                value={disabilityInsurance}
                onChange={setDisabilityInsurance}
              />
              <CustomDropdown
                firstmeeting={true}
                options={Options}
                Active={true}
                Title="Investment Management:"
                value={investmentManagement}
                onChange={setInvestmentManagement}
              />
              <CustomDropdown
                firstmeeting={true}
                options={Options}
                Active={true}
                Title="Tax Planning:"
                value={taxPlanning}
                onChange={setTaxPlanning}
              />
              <CustomDropdown
                firstmeeting={true}
                options={Options}
                Active={true}
                Title="Life Insurance:"
                value={lifeInsurance}
                onChange={setLifeInsurance}
              />
              <CustomDropdown
                firstmeeting={true}
                options={Options}
                Active={true}
                Title="Financial Planning:"
                value={financialPlan}
                onChange={setFinancialPlan}
              />
              <CustomDropdown
                firstmeeting={true}
                options={Options}
                Active={true}
                Title="Retirement Planning:"
                value={retirementPlanning}
                onChange={setRetirementPlanning}
              />
              <CustomDropdown
                firstmeeting={true}
                options={Options}
                Active={true}
                Title="Estate Planning:"
                value={estatePlanning}
                onChange={setEstatePlanning}
              />
              <CustomDropdown
                firstmeeting={true}
                options={Options}
                Active={true}
                Title="Employee Benefits:"
                value={employeeBenefits}
                onChange={setEmployeeBenefits}
              />
              <CustomDropdown
                firstmeeting={true}
                options={Options}
                Active={true}
                Title="First Home Purchase:"
                value={firstHomePurchase}
                onChange={setFirstHomePurchase}
              />
              <CustomDropdown
                firstmeeting={true}
                options={Options}
                Active={true}
                Title="Tax Preparation:"
                value={taxPreparation}
                onChange={setTaxPreparation}
              />
              <CustomDropdown
                firstmeeting={true}
                options={Options}
                Active={true}
                Title="Incorporation:"
                value={incorporation}
                onChange={setIncorporation}
              />
              <CustomDropdown
                firstmeeting={true}
                options={Options}
                Active={true}
                Title="Contract Review:"
                value={contractReview}
                onChange={setContractReview}
              />
            </FieldContianer>
          </Seciton>
          <ButtonContainer><SaveorSpouseButton onClick={handleUpdateRecord}>Submit</SaveorSpouseButton></ButtonContainer>
          {/* <Seciton style={{ padding: "30px" }}>
            <Button onClick={handleUpdateRecord} style={{ backgroundColor: 'var(--darkBlue)', color: 'white' }}>
              Submit
            </Button>
          </Seciton> */}
        </BottomSection>
      </Container>
      <Footer />
    </>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 85vh;
  gap: 50px;
  padding: 0px 5vw;
`;

const TopSection = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  gap: 30px;
`;

const Title = styled.div`
  color: var(--darkBlue);
  font-family: Georgia;
  font-size: 55px;
  font-style: normal;
  font-weight: 400;
  line-height: 90%;
  letter-spacing: -1.1px;

  @media screen and (max-width: 719px) {
    font-size: 40px;
  }
`;

const BottomSection = styled.div`
  border-radius: 15px;
  background-color: #ecf3fb;
  min-height: 100px;
  gap: 30px;
  width: 90vw;
  display:flex;
  flex-direction:column;
`;

const FieldContianer = styled.div`
  display: grid;
  padding: 20px 40px 20px 40px;
  border-radius: 15px;
  background-color: #ecf3fb;
  min-height: 100px;
  gap: 25px;
  width: 90vw;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  justify-items: center;
  align-items: baseline;
  @media screen and (max-width: 650px) {
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  }
`;
const ButtonContainer = styled.div`
  display: flex;
  background-color:#304961;
  align-items: space-around;
  justify-content:space-around;
  color: #E1E7EB;
  width: 100%
  font-size: 1.2rem; 
  font-weight: 700; 
height:9vh;
  box-shadow: 0px 0px 20px #304961;
  border-radius: 0 0 20px 20px;

  // mask-image: linear-gradient(
  //   to bottom,
  //   rgba(48, 73, 97, 0) 0%,
  //   rgba(48, 73, 97, 0.2) 20%,
  //   rgba(48, 73, 97, 0.6) 50%,
  //   rgba(48, 73, 97, 1) 80%
  // );
  // -webkit-mask-image: linear-gradient(
  //   to bottom,
  //   rgba(48, 73, 97, 0) 0%,
  //   rgba(48, 73, 97, 0.2) 20%,
  //   rgba(48, 73, 97, 0.6) 50%,
  //   rgba(48, 73, 97, 1) 80%
  // );
   

`;

const SaveorSpouseButton = styled.button`
display:flex;
background-color:  inherit;
border:none;
justify-content:center;
align-items:center;
border-radius: 0 0 20px 20px;


    cursor: pointer;
  color: #E1E7EB;
    font-size: 1.2rem; 
  font-weight: 700; 
  width:50%;
  height:100%;
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    color: #a0a0a0;
  }

  &:hover:not(:disabled) {
    text-shadow: 0 0 10px rgba(225, 231, 235, 0.8),
                 0 0 20px rgba(225, 231, 235, 0.6),
                 0 0 30px rgba(225, 231, 235, 0.4);
  }
&:hover {
  text-shadow: 0 0 10px rgba(225, 231, 235, 0.8),
               0 0 20px rgba(225, 231, 235, 0.6),
               0 0 30px rgba(225, 231, 235, 0.4);
}
          @media screen and (max-width: 690px) {
    font-size: 0.9rem; 
  font-weight: 700; 

  }
`;
const Seciton = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Text = styled.div`
  width: 100%;
  padding: 20px 40px 10px 40px;
  color: var(--darkBlue);
  font-family: Georgia;
  font-size: 25px;
  font-style: normal;
  font-weight: 400;
  line-height: 90%;
  letter-spacing: -1.1px;

  @media screen and (max-width: 919px) {
    font-size: 20px;
  }
`;

const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const Checkbox = styled.input`
  width: 16px;
  height: 16px;
  accent-color: var(--darkBlue);
  cursor: pointer;
`;

const CheckboxLabel = styled.label`
  color: var(--darkBlue);
  font-family: "Museo Sans Cyrl";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  cursor: pointer;
`;

export default FirstMeeting;
